<div class="modal">
  <div class="card card--xl">
    <div class="card-header">
      <h3 class="card-title">Dodatne informacije o radnom nalogu</h3>
    </div>
    <div class="card-body scrollable scrollable--sm">
      <ul *ngFor="let operation of order.filteredShifts">
        <li>
          Sektor: <span class="font-weight-bold">{{ operation.sector }}</span> -
          Datum: <span class="font-weight-bold">{{ operation.date || '/' }}</span> -
          Smena: <span class="font-weight-bold">{{ operation.shiftNumber || '/' }}</span><br>
          - Za operaciju <span class="font-weight-bold">"{{ operation.name }}"</span>
          od planiranih <span class="font-weight-bold">{{ operation.timePlannedEmployee || 0 | digitFormat }}</span> minuta
          izvršeno je <span class="font-weight-bold">{{ operation.timeConsumedEmployee || 0 | digitFormat }}</span>,
          od planiranih <span class="font-weight-bold">{{ operation.quantityPlanned || 0 | digitFormat }}</span> komada
          završeno je <span class="font-weight-bold">{{ operation.quantityFinished || 0 | digitFormat }}</span>.
        </li>
      </ul>
      <app-empty *ngIf="!order.filteredShifts || order.filteredShifts.length < 1" [title]="'Nema dodatnih informacija o radnom nalogu'"></app-empty>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question" (click)="emitFalse()">Nazad</button>
    </div>
  </div>
</div>